import { render, staticRenderFns } from "./ModuleNhmisdqaodkPageDetails.vue?vue&type=template&id=f0cc25e2&"
import script from "./ModuleNhmisdqaodkPageDetails.vue?vue&type=script&lang=js&"
export * from "./ModuleNhmisdqaodkPageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports